import { createSlice } from '@reduxjs/toolkit'
import { Dayjs } from 'dayjs'

export type ExerciseInfoWithConcentDate = {
  consentDate: Dayjs;
};

export type ExerciseInfoWithoutConcentDate = {
  id?: number;
  name: string;
  amountReceipt: number;
  amountClaim: number;
  receiptFile: string;
  optionalFileUrl: string;
  relativeTypeId: string;
  receiptDate: string;
  claimName: string;
  receiptNo: string;
  remark?: string;
  workOutPlaceId: number
};

export type ExerciseInf = {
  ExerciseInfo: ExerciseInfoWithConcentDate | ExerciseInfoWithoutConcentDate;
}

export const initState: ExerciseInf = {
  ExerciseInfo: {
    name: '',
    amountReceipt: 0,
    amountClaim: 0,
    receiptFile: '',
    optionalFileUrl: '',
    relativeTypeId: '',
    receiptDate: '',
    claimName: '',
    receiptNo: '',
    remark: '',
    workOutPlaceId: 0,
  },
}

const ExerciseSlice = createSlice({
  name: 'exercise',
  initialState: initState,
  reducers: {
    setExerciseInfo: (state, { payload }: PayloadWithType<ExerciseInf['ExerciseInfo']>) => {
      state.ExerciseInfo = payload
    },
    clearExerciseInfo: (state) => {
      state.ExerciseInfo = initState.ExerciseInfo
    },
  },
})

export const exerciseReducer = ExerciseSlice.reducer

export const { setExerciseInfo, clearExerciseInfo } = ExerciseSlice.actions
